module.exports = __webpack_public_path__ + "static/media/elbow1Right.f51d8661.png";